var map = {
	"./_/noticias": [
		3610,
		7065
	],
	"./de/noticias": [
		1864,
		5127
	],
	"./deAT/noticias": [
		8917,
		9232
	],
	"./en/noticias": [
		9392,
		6843
	],
	"./enCA/noticias": [
		7472,
		2055
	],
	"./es/noticias": [
		6859,
		9858
	],
	"./esAR/noticias": [
		5588,
		267
	],
	"./esCL/noticias": [
		424,
		3135
	],
	"./esMX/noticias": [
		94,
		4369
	],
	"./esPY/noticias": [
		7644,
		6575
	],
	"./esUY/noticias": [
		9661,
		7156
	],
	"./it/noticias": [
		8226,
		7697
	],
	"./pt/noticias": [
		1683,
		5406
	],
	"./ptBR/noticias": [
		615,
		6010
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4934;
module.exports = webpackAsyncContext;